import styled from 'styled-components';

export const SendOwnerInviteModalFieldsetStyled = styled.fieldset`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .editable-area[role='textbox'] {
    height: 456px;
    min-height: 456px;
  }
`;
